// @ts-nocheck

class CustomPagination extends HTMLElement {
  connectedCallback() {
    this.container = document.querySelector('.pagination-container');

    this.addEventListener('click', (e) => {
      const btn = e.target.closest('button');
      if (!btn || !this.contains(btn)) return;
      this.buttonClickHandler(btn);
    });
  }

  async buttonClickHandler(btn) {
    const nextUrl = btn.dataset.nextUrl;
    if (!nextUrl) return;

    this.classList.add('loading');
    btn.disabled = true;

    try {
      const response = await fetch(nextUrl);
      const html = await response.text();

      const template = document.createElement('template');
      template.innerHTML = html;

      const newItems = template.content.querySelectorAll('.pagination-item');
      const nextButton = template.content.querySelector('#load-more');

      if (!newItems.length) return;

      const fragment = document.createDocumentFragment();
      newItems.forEach((item) => fragment.appendChild(item));
      this.container.appendChild(fragment);

      // Notify injected-items to re-check visibility
      window.dispatchEvent(new Event('pagination-load-more'));

      this.classList.remove('loading');

      if (nextButton) {
        btn.dataset.nextUrl = nextButton.dataset.nextUrl;
      } else {
        this.querySelector('.button-wrapper')?.remove();
      }
    } catch (error) {
      console.error('Pagination fetch failed:', error);
    }

    btn.disabled = false;
  }
}

if (!customElements.get('custom-pagination')) {
  customElements.define('custom-pagination', CustomPagination);
}